<div class="sp-p-16">
  <div class="sp-mb-48">
    <h4 class="sp-mb-12">Various Avatar Types:</h4>
    <ui-avatar uiIcon="user"></ui-avatar>
    <ui-avatar uiIcon="user" uiSrc="//zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"></ui-avatar>
    <ui-avatar uiIcon="user" style="background-color: #87d068"></ui-avatar>
  </div>

  <div>
    <h4 class="sp-mb-12">Avatar Groups:</h4>
    <ui-avatar-group>
      <ui-avatar avatarIcon="user" avatarSrc="//zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"></ui-avatar>
      <ui-avatar style="background-color: #f56a00" avatarText="U"></ui-avatar>
      <ui-avatar style="background-color: #87d068" ui-tooltip tooltipTitle="NG-ZORRO User" avatarIcon="user"></ui-avatar>
      <ui-avatar style="background-color: #1890ff" avatarText="NG"></ui-avatar>
    </ui-avatar-group>
    <ui-divider></ui-divider>
    <ui-avatar-group>
      <ui-avatar avatarIcon="user" avatarSrc="//zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"></ui-avatar>
      <ui-avatar style="background-color: #f56a00" avatarText="U"></ui-avatar>
      <ui-avatar style="background-color: #fde3cf; color: #f56a00" avatarText="+2"></ui-avatar>
    </ui-avatar-group>
  </div>
</div>
